<template>
    <section>
        <div class="header-line grid-container">
            <div class="profile-label grid-item" data-qa="quotes-heading">
                Quotes
            </div>
        </div>

        <template lang="html">
            <div class="table-scroller">
                <ds-table-grid
                    :data="quotes"
                    align="center"
                    :sort-field="sortField"
                    :sort-ascending="sortAscending"
                    @sort="sortTable"
                >
                    <ds-table-grid-column
                        label="Quote number"
                        width="160"
                    >
                        <template slot-scope="quote">
                            <span>
                                {{ quote.name }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Amount"
                        width="160"
                    >
                        <template slot-scope="quote">
                            <span>
                                {{ quote.total }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        width="160"
                    >
                        <template slot-scope="quote">
                            <span>
                                <img :src="getImage(quote.orderId,quote.mostRecentStatus && quote.mostRecentStatus.status)" />
                                {{ checkValidMessage(quote.orderId,quote.mostRecentStatus && quote.mostRecentStatus.status) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status updated"
                        align="right"
                        sortable
                    >
                        <template slot-scope="quote">
                            <span v-if="quote.mostRecentStatus">
                                {{ dateFormatDate(quote.mostRecentStatus.statusDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
        </template>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        quotes: Array,
    },

    data() {
        return {
            sortAscending: false,
            sortField: 'lastUpdated',
        };
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        checkValidMessage(orderId, message) {
            if (orderId > 0) {
                return 'View Order';
            }

            if (message && message !== '') {
                return message.toString().substring(0, 1) + message.toString().substring(1).toLowerCase();
            }

            return null;
        },

        getImage(orderId, status) {
            if (orderId > 0) {
                return '/resources/ecomm/images/status-icon-accepted-and-paid.png';
            }

            switch (status) {
            case 'DECLINED':
                return '/resources/ecomm/images/status-icon-declined-and-unpaid.png';
            case 'VIEWED':
                return '/resources/ecomm/images/status-icon-viewed.png';
            case 'DRAFT':
                return '/resources/ecomm/images/status-icon-draft.png';
            case 'EXPIRED':
                return '/resources/ecomm/images/status-icon-expired.png';
            case 'SENT':
                return '/resources/ecomm/images/status-icon-sent.png';
            default:
                return '/resources/ecomm/images/status-icon-viewed.png';
            }
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.quotes = this.quotes.sort((prev, next) => {
                if (prev.mostRecentStatus.statusDate > next.mostRecentStatus.statusDate) return -1 * factor;
                if (prev.mostRecentStatus.statusDate < next.mostRecentStatus.statusDate) return 1 * factor;

                return 0;
            });
        },
    },
};

</script>

<style lang="scss" scoped>
.header-line {
    display: flex;
}

.grid-container {
    display: flex;
    margin: $spacing-250 0;
}

.grid-item {
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.table-scroller {
    white-space: nowrap;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
